module.exports = __webpack_public_path__ + "img/Central African Republic.8cc47403.gif";